import type { BaseTranslation } from "../i18n-types.js"

const en = {
  common: {
    countViews: "{{no views|1 view|?? views}}",
    bookmarks: "bookmarks",
    back: "back",
    blog: "blog",
    feeds: "feeds",
    settings: "settings",
    addBookmarks: "add bookmarks",
    addFeeds: "subscribe to feeds",
    addPosts: "create post",
    visit: "visit",
  },
} satisfies BaseTranslation

export default en
